// custom data to replace images for specific funds
export interface FundOverrideItem {
  ein: string;
  imageId?: number;
}

export interface FundAttributes {
  title: string;
  fundId: string;
  fundName: string;
  showFundDetails: boolean;
  randomize: boolean;
  bannerImage?: number | null;
  listView?: boolean;
  fundOverrides?: string;
}

export type FundEditProps = {
  attributes: FundAttributes;
  setAttributes: (attributes: Partial<FundEditProps["attributes"]>) => void;
};

export interface Funds {
  name: string;
  nonprofit_list_id: number;
}

export interface Fund {
  cnLink: string;
  donation_weight: number;
  ein: string;
  name: string;
  encompass_score_total_display?: number;
  encompass_star_rating: number;
  city?: string;
  state?: string;
  nonprofit_response?: string;
  tags?: { name: string }[];
}

export type FundMedia = {
  id: number;
  url: string;
  alt?: string;
};

export const FUND_DONATE_BUTTON_LABEL = "Support this Cause";
